<template>
    <span>
        <table class="layui-hide">
            <slot></slot>
        </table>
        <div class="layui-table-page" style="height:33px;line-height: 33px;width: auto;border-width: 0px 1px 1px 1px;margin-bottom: 0px;background: #FFF;" v-show="showPage">
            <div class="layui-box layui-laypage layui-laypage-default">
                <a class="layui-laypage-prev" @click="prePage()"
                v-bind:class="{'layui-disabled' : (pageInfo.pageIndex == 1) }">
                    <i class="layui-icon"></i>
                </a>
                <a v-bind:class="{'layui-laypage-curr' : (pIdx == pageInfo.pageIndex)}"
                v-for="pIdx in calPageRange()" v-bind:key="pIdx" @click="toPage(pIdx)" style="cursor: pointer">
                    <em class="layui-laypage-em"></em>
                    <em>{{pIdx}}</em>
                </a>
                <a class="layui-laypage-next" @click="nextPage()"
                    v-bind:class="{'layui-disabled' : (pageInfo.pageIndex == pageInfo.pageTotal) }">
                    <i class="layui-icon"></i>
                </a>
                <span class="layui-laypage-count">
                    总 <em v-text="pageInfo.pageTotal"></em> 页,
                    共 <em v-text="pageInfo.totalNum"></em> 条
                </span>
                <span class="layui-laypage-limits">
                    <select @change="pageChange()" v-model="pageInfo.pageSize"  lay-ignore>
                        <option v-for="option in pageInfo.pageOptions" v-bind:key="option" v-bind:value="option" v-text="option + '条/页'"></option>
                    </select>
                </span>
                <span class="layui-laypage-skip" v-show="showToPage">
                    到第<input type="text" class="layui-input" v-model="pageInfo.toPageIndex">页
                    <button type="button" class="layui-laypage-btn" @click="toPage(pageInfo.toPageIndex)">确定</button>
                </span>
            </div>
        </div>
    </span>
</template>

<script>

export default {
    name: 'LayuiTable',
    props: {
        requestUniqueId: {
            type: String, // // 请求唯一标识，必须有
            default: () => {
                return 'layui-table-' + window.uuid();
            },
        },
        fromIndex: {
          type: String,
          default: ''
        },
        // 表名
        tableName: {
            type   : String,
            default: '',
            required: true
        },
        // 视图名
        viewName: {
            type   : String,
            default: '',
        },
        lazy: {
            type: Boolean,
            default: false,
        },
        slaveTables: {
            type: Array,
            default: ()=> {
                return [];
            }
        },
        sort: {
            type: Array,
            default: () => {
                return []
            }
        },
        //line （行边框风格）row （列边框风格）nob （无边框风格）默认无
        skin: {
            type: String,
            default: '',
        },
        height: {
            type: String,
            default: 'full-222',
        },
        //开启合计行，默认不开启
        totalRow: {
            type: Boolean,
            default: false,
        },
        // 默认查询条件，比如state=1， 那么table加载的时候会查询state=1的数据
        // 如果在其他地方设置了关于state的值，那么默认值失效
        defaultCondition: {
            type: Object,
            default: () => {
                return {};
            }
        },
        // 要查询的字段，默认查询所有
        selectFields: {
            type   : String,
            default: '',
        },
         // 如果配置了selectFields,该属性失效
        unSelectFields: {
            type   : String,
            default: '',
        },
        pageSize: {
            type   : Number,
        },
        pageRange: {
            type   : Number,
        },
        pageOptions: {
            type: Array,
            default: () => {
                return []
            }
        },
        showToPage: {
            type: Boolean,
            default: true,
        },
        tableEventPrefix: {
            type: String,
            default: 'table-event-'
        },
        renderRow : {
            type: Function,
        },
        // 是否显示分页组件
        showPage : {
            type: Boolean,
            default: () => {
                return true;
            }
        },
        renderDone : {
            type: Function,
        },
        beforeRender : {
            type: Function
        },
        beforeLoad: { type: Function },
        afterLoad: { type: Function }
    },
    activated() {
        if(this._layuiEl) {
            this._layuiEl.resize();
        }
    },
    data() {
        return {
            id : null,
            el : null,
            data: [],
            checkedRows: [],
            queryObject: {

            },
            pageInfo: {
                pageIndex: 1,
                pageSize: 25,
                pageTotal: 1,
                totalNum: 5,
                pageRange: 8,
                pageOptions: [15, 25, 50, 100]
            },
            _layuiEl : null,
        }
    },
    mounted() {
        var that = this;
        this.translateMap = {};
        var filters = [];

        if(this.pageSize) {
            this.pageInfo.pageSize = this.pageSize;
        }
        if(this.pageRange) {
            this.pageInfo.pageRange = this.pageRange;
        }
        if(this.pageOptions && this.pageOptions.length > 0) {
            this.pageInfo.pageOptions = this.pageOptions;
        }
        var element = this.el = $(this.$el);
        var id = this.id =  this.uuid();
        var tableEl = element.find('table');
        tableEl.attr('id', id);
        tableEl.attr('lay-filter', id);
        var table_header_config = [];
        var tr = tableEl.children();
        for(var i = 0 ; i < tr.length; i++) {
            var col = $(tr[i]).find('div');
            var colConfig = [];
            table_header_config.push(colConfig);
            for(var j = 0 ; j < col.length; j++) {
                var colEl = $(col[j]);
                var field = colEl.attr('field');
                var title = colEl.attr('title');
                var width = colEl.attr('width');
                var align = colEl.attr('align');
                var fixed = colEl.attr('fixed');
                var colspan = colEl.attr('colspan');
                var rowspan = colEl.attr('rowspan');
                var checkbox = colEl.attr('checkbox');
                var radio = colEl.attr('radio');
                var toolbar = colEl.attr('toolbar');
                var translateDomain = colEl.attr('translateDomain');
                var colGroup = colEl.attr('colGroup');
                var sort = colEl.attr('sort');
                var filter = colEl.attr('filter');
                //扩展开启合计行
                var totalRow = colEl.attr('totalRow');
                var totalRowText = colEl.attr('totalRowText');
                var height = colEl.attr('height');
                var configItem = {
                };
                if(height) {
                    configItem.height = height;
                }
                if(colGroup == 'true') {
                    configItem.colGroup = true;
                }
                if(checkbox == 'true') {
                    configItem.type = 'checkbox';
                } else if(radio == 'true'){
                    configItem.type = 'radio';
                }
                if(title) {
                    configItem.title = title;
                }
                if(field) {
                    configItem.field = field.toUpperCase();
                }
                if(align) {
                    configItem.align = align;
                }
                if(fixed) {
                    configItem.fixed = fixed;
                }
                if(colspan) {
                    configItem.colspan = colspan;
                }
                if(rowspan) {
                    configItem.rowspan = rowspan;
                }
                if (width) {
                    configItem.width  = Number(width);
                }
                if(totalRow){
                    configItem.totalRow  = Boolean(totalRow);
                }
                if(totalRowText){
                    configItem.totalRowText = totalRowText;
                }
                if (translateDomain) {
                    this.translateMap[field] = translateDomain;
                }
                if(toolbar != undefined) {
                   var toolbarId = 'toolbar-' + this.uuid();
                   colEl.find('script').attr('id', toolbarId);
                   configItem.toolbar = '#' + toolbarId;
                } else {
                    if (colEl.find('script').length > 0) {
                        var templateId = "templateId" + this.uuid();
                        colEl.find('script').attr('id', templateId);
                        configItem.templet = "#" + templateId;
                    }
                }
                //排序
                if(sort) {
                    configItem.sort = true;
                }
                //字段筛选
                if(filter) {
                    filter = JSON.parse(filter);
                    // domainData格式  [{text: '',value: ''},....]
                    var domainKey = filter.domain;
                    var domainData = this.dict.getData(domainKey);
                    filters.push({ field: field, type:'checkbox',  data: domainData});

                }
                colConfig.push(configItem);
            }
        }

        let _tableFilterEl  = this.layui.tableFilter.render({
            'elem' : '#' + this.id,
            parent : 'body',
            'mode' : 'api',
            'filters' : filters,
            'done': function(selectfilters){
                //先根据配置的filter清除查询条件
                for(var filter in filters) {
                    var field = filters[filter].field;
                    if(field) {
                        var idx = -1;
                        if(( idx = field.indexOf("_DESC")) > 0 ||
                            ( idx = field.indexOf("_TRANSLATE")) > 0) {
                            field = field.substring(0, idx);
                        }
                        that.queryObject[field + ':1'] = null;
                    }

                }
                for(var p in selectfilters) {
                    var field = p;
                    var values = selectfilters[p];
                    var idx = -1;
                    if(( idx = field.indexOf("_DESC")) > 0 ||
                        ( idx = field.indexOf("_TRANSLATE")) > 0) {
                        field = field.substring(0, idx);
                    }
                    //用in查询
                    var inArr = [];
                    for(var i = 0 ; i < values.length; i++) {
                        inArr.push( values[i]);
                    }
                    that.queryObject[field + ':1'] = inArr.join(",");
                }
                that.load();
            }
        })

        this._layuiEl = this.layui.table.render({
            id: this.id,
            elem: '#' + this.id,
            limit: 9999, // 显示多少条记录，如果不配置默认只显示data的前10条记录
            cellMinWidth: 80,
            height: this.height,
            data: this.data,
            totalRow: this.totalRow,
            hoverTips: true,
            cols: table_header_config,
            autoSort: false, //关闭自动排序
            done: function (res, curr, count) {
                if(filters.length > 0) {
                    _tableFilterEl.reload();
                }

                if(that.renderDone) {
                    that.renderDone();
                }
            }
        });

        //监听工具条
        this.layui.table.on('tool(' + this.id + ')', (obj) => {
            var data = obj.data;
            this.$emit(this.tableEventPrefix + obj.event, {data: data, el: obj.tr});
        });

        // check事件，不派发，自动处理checkedRows逻辑
        this.layui.table.on('checkbox(' + this.id + ')', function(obj) {
            that.handleCheckEvent(obj, that);
        });

        this.layui.table.on('radio(' + this.id + ')', function(obj) {
            that.handleRadioEvent(obj, that);
        })

         // 1.高亮行
         // 2.派发行单击事件
        this.layui.table.on('row(' + this.id + ')', function(obj) {
            var curClickEl = this;
            //标注选中样式
            obj.tr.addClass('layui-table-click').siblings().removeClass('layui-table-click');
            that.$emit('rowClick', { data: obj.data , el: obj.tr});
        });

        // 派发行双击事件
        this.layui.table.on('rowDouble(' + this.id + ')', function(obj) {
            var curClickEl = this;
            that.$emit('rowDouble', { data: obj.data , el: obj.tr});
        });

        //监听排序
        this.layui.table.on('sort(' + this.id + ')', (obj) => {
            var field = obj.field.toUpperCase();
            field = field.replaceAll("_DESC","");//如果是翻译字段，去掉翻译配置
            var order_type = obj.type.toUpperCase();
            that.sort = [field + ":" + order_type];
            that.load();
            return true;
        });

        // 如果开启懒加载，就不执行load方法
        if(!this.lazy) {
            this.load();
        }
    },
    methods: {
        handleCheckEvent(obj, that){
             if(obj.checked) {
                if(obj.type == 'all') {
                    that.checkedRows = [...that.data];
                    that.$emit('check');
                } else {
                    for(var i = 0 ; i < that.data.length; i++) {
                        if(obj.data._id == that.data[i]._id) {
                            that.checkedRows.push(that.data[i]);
                            that.$emit('check');
                            return ;
                        }
                    }
                }
            } else {
                // 取消全选
                if(obj.type == 'all') {
                    that.checkedRows = [];
                    that.$emit('check');
                } else {
                    for(var i = 0 ; i < that.data.length; i++) {
                        if(obj.data._id == that.data[i]._id) {
                            that.checkedRows.remove(that.data[i]);
                            that.$emit('check');
                            return ;
                        }
                    }
                }
            }

        },
        handleRadioEvent(obj, that){
            that.checkedRows = [];
            for(var i = 0 ; i < that.data.length; i++) {
                if(obj.data._id == that.data[i]._id) {
                    that.checkedRows.push(that.data[i]);
                    that.$emit('check');
                    return ;
                }
            }
        },
        enhance() {
            var point = 1;
            this.data.forEach((e) => {
                e._id = this.id + '-' + (this.pageInfo.pageIndex - 1) * this.pageInfo.pageSize + point;
                e._NUMBER = this.pageInfo.pageSize ? ((this.pageInfo.pageIndex - 1) * this.pageInfo.pageSize + (point++)) : point++;//处理不分页的情况
                // 处理翻译
                for(var attr in e) {
                    var domain = null;
                    var value = null;
                    if((value = e[attr]) != null
                        && ((domain = this.translateMap[attr + '_DESC'])
                        || (domain = this.translateMap[attr + '_TRANSLATE']))) {
                        var translateResult = this.dict.getTranslate(domain, value);
                        // 赋值给field_DESC属性，如果取不到翻译的值就用原始值
                        e[attr + '_DESC'] = e[attr + '_TRANSLATE'] = translateResult ? translateResult : value;
                    }
                }
                let user = this.security.getUser();
                if(user){
                    if(user.getRoles()) {
                        e._role = user.getRoles().join(",");
                    }
                    if(user.getMarks()) {
                        e._mark = user.getMarks().join(",");
                    }
                }
                if(this.renderRow) {
                    this.renderRow(e);
                }

            });
        },
        resize() {
            this._layuiEl.resize();
        },
        clear() {
            this.checkedRow = null;
            this.checkedRows = [];
            this.queryObject = {};
            this.pageInfo.pageTotal = 0;
            this.pageInfo.totalNum = 0;
            this.data = [];
            this._layuiEl = this.layui.table.reload(this.id, {data: this.data});
            this.resize();
        },
        setColsWidth() {
            this._layuiEl.setColsWidth();
        },
        getTableName() {
            return this.tableName;
        },
        getViewName() {
            return this.viewName;
        },
        getData() {
            return this.data;
        },
        getcheckedRows() {
            return this.checkedRows;
        },
        search() {
            this.pageInfo.pageIndex = 1;
            this.load();
        },
        getSlaveTables() {
            return this.slaveTables;
        },
        getUnselectFields(){
            return this.unSelectFields;
        },
        load () {
            // todo 特例，客户服务请求高级查询如果选择的状态包含 现场处理， 则查询条件改为  in '2,11,12,13,14,15,16,17,18'
            if (this.fromIndex === 'serviceRequestIndex') {
              if (this.queryObject.hasOwnProperty('ORDER_STATE:1')) {
                let order_state_str = this.queryObject['ORDER_STATE:1'];

                if (order_state_str.indexOf('2') != -1) {
                  let order_state_array = order_state_str.split(',')
                  order_state_array = order_state_array.filter(p => p != '2')

                  let default_order_state = '2,11,12,13,14,15,16,17,18';
                  let default_order_state_array = default_order_state.split(",")

                  let new_order_state_array = default_order_state_array.concat(order_state_array)

                  this.queryObject['ORDER_STATE:1'] =  new_order_state_array.join(",")
                }
              }
            }

            var p2 = $.extend(true, {}, this.defaultCondition, this.queryObject);
            var queryTableName = this.viewName ? this.viewName : this.tableName;
            if (this.beforeLoad) {
              this.beforeLoad()
            } else {
              this.layer.showLoading();
            }
            this.api.pageQuery(
                            queryTableName,
                            {p2: p2, p3: this.pageInfo, p9: this.selectFields, p10: this.sort, p11: this.unSelectFields},
                            this.requestUniqueId)
            .then(response => {
                    this.layer.closeLoading()
                this.layer.closeLoading();
                if (response.errorMsg) {
                    console.error(response.errorMsg);
                } else {
                    this.checkedRow = null;
                    this.checkedRows = [];
                    var result = response.result;
                    var records = result.records;
                    this.pageInfo.pageTotal = result.pageInfo.pageTotal;
                    this.pageInfo.totalNum = result.pageInfo.totalNum;
                    this.data = records;
                    if(this.beforeRender) {
                        this.beforeRender(this.data);
                    }
                    this.enhance();
                    this._layuiEl = this.layui.table.reload(this.id, {data: this.data});
                   // this.data = this._layuiEl.config.data;
                    this.resize();
                    if (this.afterLoad) {
                        this.afterLoad(this.data)
                    }
                }
            }, err => { this.afterLoad && this.afterLoad() });
        },
        loadSlave(form, editRow, primaryKey, cb) {
            var p2 = {};
            p2[primaryKey] = editRow[primaryKey];
            this.api.queryList(
                        this.tableName,
                        { p2: p2,  p8: this.slaveTables },
                        this.requestUniqueId
                ).then(response => {
                   var result = response.result;
                   result = result[0];
                   if(result) {
                       form.$set(editRow, '_SLAVE', result._SLAVE);
                       if(cb){
                           cb(result);
                       }
                   }
            });
        },
        reset () {
            for(var p in this.queryObject) {
                this.queryObject[p] = '';
            }
            this.pageInfo.pageIndex = 1;
            this.load();
        },
        setCheckRow(row) {
            var trs = [this.el.find(".layui-table-fixed").find("tr"), this.el.find(".layui-table-body").find("tr")];
            for(var i = 0 ; i < this.data.length; i++) {
                if(row._id == this.data[i]._id) {
                    var flag = false;
                    for(var j = 0 ; j < trs.length; j++) {
                        if(flag) break;
                        for(var k = 0 ; k < $(trs[j]).length; k ++) {
                            var tr = $(trs[j][k]);
                            if(tr.data('index') == i) {
                                var layui_form_checkbox = tr.find(".layui-form-checkbox,.layui-form-radio");
                                if(layui_form_checkbox.length > 0) {
                                    layui_form_checkbox.trigger("click");
                                    flag = true;
                                    break;
                                }
                            }
                        }

                    }
                    return ;
                }
            }
        },
        checkRow(row){
             var trs = [this.el.find(".layui-table-fixed").find("tr"), this.el.find(".layui-table-body").find("tr")];
             for(var i = 0 ; i < this.data.length; i++) {
                if(row._id == this.data[i]._id) {
                    var flag = false;
                    for(var j = 0 ; j < trs.length; j++) {
                        if(flag) break;
                        for(var k = 0 ; k < $(trs[j]).length; k ++) {
                            var tr = $(trs[j][k]);
                            if(tr.data('index') == i) {
                                var checkEl = tr.find(".layui-form-checkbox");
                                var radioEl = tr.find(".layui-form-radio");
                                if(checkEl.length) {
                                    if(checkEl[0].className == "layui-unselect layui-form-checkbox layui-form-checked") {
                                        //设置为未选中的样式
                                        $(checkEl).removeClass("layui-form-checked");
                                    } else {
                                        //设置为选中的样式
                                        $(checkEl).addClass("layui-form-checked");
                                    }
                                }
                                if(radioEl.length) {
                                    if(radioEl[0].className == "layui-unselect layui-form-radio layui-form-radioed") {
                                        //设置为未选中的样式
                                        $(radioEl).removeClass("layui-form-radioed");
                                        $(radioEl).find('.layui-icon').removeClass('layui-anim-scaleSpring').text('');;
                                    } else {
                                        //设置为选中的样式
                                        $(radioEl).addClass("layui-form-radioed");
                                        $(radioEl).find('.layui-icon').addClass('layui-anim-scaleSpring').text('');
                                    }
                                }
                                return;
                            }
                        }

                    }
                    return ;
                }
            }
        },
        unCheckAll(){
            for(var i = 0; i < this.checkedRows.length; i++){
                this.setCheckRow(this.checkedRows[i]);
            }
        },
        delRows (rows, { isLogic = false, reqId = '' } = {}){
            if(!Array.isArray(rows)){
                rows = [rows];
            }
            this.layer.openConfirm('确定要删除这<span style="color:red">' + rows.length + '</span>条记录吗?', ()=> {
                let req = ''
                if (isLogic) {
                  rows = rows.map(row => {
                    row.DELETED = '1'
                    row.IS_NEW = false
                    return row
                  })
                  req = this.api.saveList(this.tableName, rows, reqId || this.requestUniqueId)
                } else {
                  req = this.api.delRows(this.tableName, { p5: rows, p8: this.slaveTables}, this.requestUniqueId)
                }

                req.then(response => {
                    if(response.errorMsg) {
                         this.layer.openAlert(response.errorMsg, false);
                    } else {
                        this.load();
                        this.layer.openSuccess('删除成功!');
                    }

                });
            });
        },
        delCheckedRows({ isLogic = false, reqId = '' } = {}) {
            if (this.checkedRows.length == 0) {
                this.layer.openAlert('请至少选择一条记录!');
                return;
            }
            this.layer.openConfirm('确定要删除这<span style="color:red">' + this.checkedRows.length + '</span>条记录吗?', ()=> {
                let req = ''
                if (isLogic) {
                  let rows = this.checkedRows.map(row => {
                    row.DELETED = '1'
                    row.IS_NEW = false
                    return row
                  })
                  req = this.api.saveList(this.tableName, rows, reqId || this.requestUniqueId)
                } else {
                  req = this.api.delRows(this.tableName, { p5: this.checkedRows, p8: this.slaveTables}, this.requestUniqueId)
                }
                req.then(response => {
                    if(response.errorMsg) {
                        this.layer.openAlert(response.errorMsg, false);
                    } else {
                        this.load();
                        this.layer.openSuccess('删除成功!');
                    }
                });
            });
        },
        toPage: function(toIdx){
            if(toIdx > 0 && toIdx <= this.pageInfo.pageTotal) {
                this.pageInfo.pageIndex = toIdx;
                this.load();
            }
        },
        calPageRange : function(){
            var pageList = [];
            var diff = 0;
            var range = 0;
            if(!this.pageInfo.pageTotal) return [];
            if(this.pageInfo.pageTotal <= this.pageInfo.pageRange){
                range = this.pageInfo.pageTotal;
            }else{
                range = this.pageInfo.pageRange;
                var curPageIndex = this.pageInfo.pageIndex;
                var half = Math.ceil(this.pageInfo.pageRange / 2) + 1;
                diff = half - curPageIndex >= 0 ? 0 : half - curPageIndex;
            }
            var start = 1 + Math.abs(diff);
            var limit = range + Math.abs(diff);
            if(limit > this.pageInfo.pageTotal){
                limit = this.pageInfo.pageTotal;
                start = start - (this.pageInfo.pageRange + Math.abs(diff) - this.pageInfo.pageTotal);
            }
            for(var i = start ; i <= limit; i++){
                pageList.push(i);
            }
            return pageList;
        },
        prePage: function(){
            if(this.pageInfo.pageIndex > 1){
                this.pageInfo.pageIndex--;
                this.load();
            }
        },
        nextPage: function(){
            if(this.pageInfo.pageIndex <= this.pageInfo.pageTotal - 1){
                this.pageInfo.pageIndex++;
                this.load();
            }
        },
        pageChange: function() {
            this.pageInfo.pageIndex=1;
            this.load();
        }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/common/LayuiTable.vue